// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';
import { RadioButton } from '@ta/core-ui.radio-button';
import styles from './ReportIAPRadio.css';

type Props = {|
  value: string,
  selected: boolean,
  labelText: React.Node,
  onSelect?: () => void,
  children: React.Node,
|};

const ReportIAPRadio = ({ value, selected, labelText, onSelect, children }: Props) => (
  <div className={styles.iap_radio_container}>
    <RadioButton
      value={value}
      selected={selected}
      onSelect={onSelect}
      label={<span className={selected ? styles.selected : styles.label}>{labelText}</span>}
    />
    <div className={styles.children}>{selected && children}</div>
  </div>
);

export default ReportIAPRadio;
